function RoundedLike({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_684_462)">
        <path d="M1.22917 7.0293C0.967766 7.0293 0.755859 7.24123 0.755859 7.50261V14.4544C0.755859 14.7158 0.967797 14.9277 1.22917 14.9277H4.08083V7.0293H1.22917Z" fill=${`"${col}"`}/>
        <path d="M16.7436 9.64336C16.7436 9.04252 16.4207 8.51564 15.9394 8.22708C16.1238 7.9608 16.232 7.63777 16.232 7.29005C16.232 6.38027 15.4918 5.64008 14.582 5.64008H11.0989C11.2057 5.15633 11.3517 4.43042 11.4534 3.67051C11.7179 1.69297 11.5371 0.596253 10.8844 0.219096C10.4774 -0.0159978 10.0387 -0.0636854 9.64895 0.0846899C9.34785 0.199378 8.94123 0.481347 8.70951 1.17338L7.79407 3.57029C7.32997 4.71645 5.90875 5.91973 5.02734 6.58508V15.1375C6.66091 15.7099 8.36554 16 10.1046 16H13.8998C14.8096 16 15.5498 15.2598 15.5498 14.3501C15.5498 14.0315 15.459 13.7337 15.302 13.4812C15.852 13.2133 16.2319 12.6485 16.2319 11.9967C16.2319 11.649 16.1238 11.326 15.9394 11.0597C16.4207 10.7711 16.7436 10.2442 16.7436 9.64336Z" fill=${`"${col}"`}/>
      </g>
      <defs>
        <clipPath id="clip0_684_462">
          <rect width="16" height="16" fill=${`"${col}"`} transform="translate(0.75)"/>
        </clipPath>
      </defs>
    </svg>
  `;
  return baseXml;
}

export default RoundedLike;
